declare let THREE: any;

export class PaperSize extends (THREE.LineSegments as { new(geometry, material): any; }) {

  private static rotationTransform = new THREE.Matrix4().makeRotationX(THREE.Math.degToRad(90));
  static readonly Name = 'paperSize';

  constructor() {
    const geometry = new THREE.EdgesGeometry(new THREE.PlaneBufferGeometry(1, 1)
      .applyMatrix(PaperSize.rotationTransform));
    const material = new THREE.LineDashedMaterial({
      color: 0xff0000,
      side: THREE.DoubleSide,
      dashSize: 0.01,
      gapSize: 0.01,
      depthTest: false,
      depthWrite: false
    });
    super(
      geometry,
      material
    );
    this.name = PaperSize.Name;
    this.visible = false;
  }

  raycast() {
    return [];
  }

  update(width: number, height: number) {
    this.visible = true;
    this.scale.set(width, 1, height);
    this.computeLineDistances();
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/PaperSize.ts